/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ remaining: NonNullable<unknown> }} Spaces_Rate_Limit_WarningInputs */



/**
* | output |
* | --- |
* | "GitHub API rate limit low ({remaining} remaining)" |
*
* @param {Spaces_Rate_Limit_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_rate_limit_warning = /** @type {((inputs: Spaces_Rate_Limit_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Rate_Limit_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`GitHub API Rate-Limit niedrig (${i?.remaining} verbleibend)`)
	return /** @type {LocalizedString} */ (`GitHub API rate limit low (${i?.remaining} remaining)`)
});